import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/global-error.tsx")